import Vue from "vue";
import VueRouter from "vue-router";
import routes from './routes'
Vue.use(VueRouter);


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


// Auth logic
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    
    if ( !window.localStorage.getItem('tK') ) {
      next({ name: 'login', query: to.query})
      // next({ name: 'welcome' })
    } else {
      next() // go to wherever I'm going
    }
  }else if (to.matched.some(record => record.meta.requiresGuest)){
    if (window.localStorage.getItem('tK')) {
      next({ name: 'home', query: to.query})
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth or guest, make sure to always call next()!
  }
})

export default router;
